import { render, staticRenderFns } from "./DialogSpostaElemento.vue?vue&type=template&id=4f63c614"
import script from "./DialogSpostaElemento.vue?vue&type=script&lang=js"
export * from "./DialogSpostaElemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports